export const PATH = {
    HOME:'/procedure/summary-registration-courses',
    CREATE:'/procedure/summary-registration-courses/create/:id',
    DETAIL:'/procedure/summary-registration-courses/details/:id'
}